var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"facebook squared\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.4165 7.875V18.875C26.4165 22.6719 23.3384 25.75 19.5415 25.75H8.5415C4.74455 25.75 1.6665 22.6719 1.6665 18.875V7.875C1.6665 4.07805 4.74455 1 8.5415 1H19.5415C23.3384 1 26.4165 4.07805 26.4165 7.875Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6665 23.3365C12.6665 19.6138 12.6665 15.891 12.6665 12.1683C12.6665 9.45375 13.354 7.20459 18.1665 7.20459",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.91626 13.4092H12.6663H18.1663",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b7c1ec97942805d425fed9634344af47.svg";
export { ForwardRef as ReactComponent };